<template>
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
  >
    <path d="M8.85563 6.65498C8.02249 6.19354 7 6.79608 7 7.74847V13.2516C7 14.204 8.0225 14.8065 8.85563 14.3451L14.6134 11.1561C14.852 11.024 15 10.7727 15 10.5C15 10.2273 14.852 9.97607 14.6134 9.84393L8.85563 6.65498ZM10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 16.0228 4.47715 20.5 10 20.5C15.5228 20.5 20 16.0228 20 10.5C20 4.97715 15.5228 0.5 10 0.5ZM1.5 10.5C1.5 5.80558 5.30558 2 10 2C14.6944 2 18.5 5.80558 18.5 10.5C18.5 15.1944 14.6944 19 10 19C5.30558 19 1.5 15.1944 1.5 10.5Z" />
  </svg>
</template>
